import { useTranslate } from '@tolgee/react';
import Clipboard from 'clipboard';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { CopySvg } from '../../../assets/icons';
import theme from '../../../assets/theme';
import { Input } from '../../_atoms/_Input';
import { Button } from '../../_atoms/Button';
import { IconWrapper } from '../../_atoms/IconWrapper';
const CopyLink = ({ link, onCopy }: { link: string; onCopy?: () => void }) => {
  const shareLinkRef = useRef(new Clipboard('#copy_url'));
  const { t } = useTranslate();
  const [copySuccess, setCopySuccess] = useState(false);
  useEffect(() => {
    const clip = shareLinkRef.current;
    clip.on('success', () => {
      onCopy && onCopy();
      setCopySuccess(true);
    });

    return () => {
      clip.destroy();
    };
  }, [onCopy]);

  useEffect(() => {
    const ref = setTimeout(() => {
      if (copySuccess) {
        setCopySuccess(false);
      }
    }, 3000);
    return () => {
      clearTimeout(ref);
    };
  }, [copySuccess]);

  return (
    <InputContainer
      role="button"
      id="copy_url"
      $isCopied={copySuccess}
      data-clipboard-text={link}
    >
      <CopyInput value={link} />
      <CopyInputButton type={'ghost'}>
        <span>
          {copySuccess ? (
            t('Copied')
          ) : (
            <IconWrapper>
              <CopySvg />
              {t('Copy link')}
            </IconWrapper>
          )}
        </span>
      </CopyInputButton>
    </InputContainer>
  );
};

const CopyInput = styled(Input)`
  min-width: 250px;
  width: 100%;
`;
const CopyInputButton = styled(Button)`
  margin-left: -130px;
  padding: 5;
  border: solid 1px ${theme.colors.black};
  background-color: white;

  height: 30px;
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  &:hover {
    border: solid 1px ${theme.colors.lightGreen};
    background-color: white;
  }
`;
const InputContainer = styled.div<{ $isCopied: boolean }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  border-radius: 10px 0 0 10px;
  width: 100%;
  padding-right: 20px;
  min-width: 250px;
  margin-right: 5px;
  border-radius: 10px;

  @media (max-width: 690px) {
    input {
      cursor: pointer;
      font-size: 16px;
    }

    &:after {
      font-size: 16px;
      top: 3px;
    }
  }
`;

export default CopyLink;
